import DynamicModal from "./DynamicModal";
import ToggleBtn from "./ToggleBtn";
import SwipAlt from "../assets/img/icons/swip-alt.svg";
import SwipAltOff from "../assets/img/icons/swip-alt-off.svg";
import { getConnectorStatusClass } from "../helpers/connectorStatusHelpers";

/**
 * Modal component for controlling charging (start/stop)
 *
 * @param {Object} props Component properties
 * @param {boolean} props.isOpen Whether the modal is open
 * @param {Function} props.onClose Callback when modal closes
 * @param {string} props.chargeAction "connect" or "stop"
 * @param {boolean} props.isToggleOn Current toggle state
 * @param {Function} props.onToggle Callback when toggle changes
 * @param {Function} props.onNext Callback when next button is clicked
 * @param {Object} props.t Translation function
 * @param {string} props.connectorLabel Label of the connector to charge
 * @param {string} props.connectorStatus Status of the connector ("available", "unavailable", etc.)
 */
const ChargingControlModal = ({
    isOpen,
    onClose,
    chargeAction,
    isToggleOn,
    onToggle,
    onNext,
    t,
    connectorLabel = "Water-1",
    connectorStatus = "Available", // Default to Available
}) => {
    const baseClassName =
        chargeAction === "connect"
            ? "boater-step1sub2__terminal-details"
            : "boater-step4__terminal-details";

    const modalTitle =
        chargeAction === "start" || chargeAction === "connect"
            ? t("load_instruction")
            : t("unload_instruction");

    const showNextButton =
        ((chargeAction === "start" || chargeAction === "connect") &&
            isToggleOn) ||
        (chargeAction === "stop" && !isToggleOn);

    const iconSrc =
        chargeAction === "connect" || chargeAction === "start"
            ? SwipAlt
            : SwipAltOff;

    // Use the helper function instead of lowercase conversion
    const statusClass = getConnectorStatusClass(connectorStatus);

    return (
        <DynamicModal
            open={isOpen}
            onClose={onClose}
            extraClasses={{
                content: baseClassName,
            }}
        >
            <div className={`${baseClassName}__header`}>
                <img src={iconSrc} width="50" height="60" alt="" />
                <h2 className="title-connection">{modalTitle}</h2>
            </div>

            <div className={`${baseClassName}__connection`}>
                <h3 className={`${baseClassName}__connection-availability`}>
                    <span className="terminal-name">{connectorLabel}</span>
                    <span className={`status ${statusClass}`}>
                        {t(connectorStatus)}
                    </span>
                </h3>
            </div>

            <div className={`${baseClassName}__connection-charge`}>
                <ToggleBtn
                    isOn={isToggleOn}
                    onLabel={t("load")}
                    offLabel={t("stop")}
                    backgroundColor="#3B6ED5"
                    toggleColor="#BBD7FF"
                    onToggle={onToggle}
                />
            </div>

            {showNextButton && (
                <div className={`${baseClassName}__connection-next`}>
                    <button
                        type="button"
                        className="vnf-btn vnf-btn-quaternary-outline vnf-btn-quaternary-arrow"
                        onClick={onNext}
                    >
                        {t("Next")}
                    </button>
                </div>
            )}
        </DynamicModal>
    );
};

export default ChargingControlModal;
